import script from "./AccountOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountOverview.vue?vue&type=script&setup=true&lang=js"

import "./AccountOverview.vue?vue&type=style&index=0&id=6f0dffd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0dffd9"]])

export default __exports__